import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import { ButtonLink } from '~/ui';
import { useTranslation } from 'react-i18next';
import QuestionnairesBoard from './QuestionnairesBoard/QuestionnairesBoard';
import { QuestionnairesPageInfo } from './QuestionnairesPageInfo/QuestionnairesPageInfo';
import { useState } from 'react';

const Questionnaires = (): JSX.Element => {
  const { t } = useTranslation();
  const [statusFilter, setStatusFilter] = useState('');

  return (
    <Page
      heading={
        <Heading
          text={t('questionnaires')}
          actions={
            <ButtonLink
              text={t('add_new_questionnaire')}
              to="/questionnaires/create"
            />
          }
        />
      }
    >
      <QuestionnairesPageInfo statusFilter={statusFilter} setStatusFilter={setStatusFilter} />
      <QuestionnairesBoard statusFilter={statusFilter} />
    </Page>
  );
};

export default Questionnaires;
